export const PAYMENT_SUCCESS_TITLE = 'Всё хорошо: мы получили деньги, юристы взялись за работу';
export const PAYMENT_SUCCESS_PAYMENT_ID_PREPEND = 'Номер вашей заявки';
export const PAYMENT_SUCCESS_MESSAGE =
  'Отчёт с рекомендациями придёт вам на почту в течение 3-х рабочих дней. На всякий случай, проверяйте папку «Спам» — иногда письма могут попадать туда.';
export const PAYMENT_SUCCESS_ACTION = 'Спасибо, жду!';
